import type { ReactNode } from 'react';

export const symbol_android_wifi_4_bar_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M790-183 496-388h-16q-42 0-81.5 11.5T324-343q-14 9-31 8t-29-13q-12-12-11.5-28t14.5-25q29-20 60.5-35t66.5-23l-87-61q-27 11-52.5 25.5T206-462q-14 11-30.5 10T147-465q-12-12-11.5-27.5T149-519q20-16 40-29.5t42-24.5l-78-54q-17 11-33 22t-32 24q-14 11-30.5 10.5T29-583q-12-12-12-28t13-27q13-11 25.5-20.5T82-677l-18-12q-14-10-16.5-26t7.5-30q10-14 25.5-17t29.5 7l726 507q14 10 16.5 26t-7.5 30q-10 14-25.5 16.5T790-183Zm-361 2q-21-21-21-51 0-29 21.5-50t50.5-21q30 0 51 20.5t21 50.5q0 30-21 51t-51 21q-30 0-51-21Zm-69-527-89-60q51-16 103-24t106-8q125 0 240 41.5T929-638q13 11 14 27t-11 28q-12 12-29 12.5T872-581q-84-68-184-103.5T480-720q-31 0-61 3t-59 9Zm368 258L462-635h19q88 0 170 27.5T803-527q17 13 18 34t-14 36q-16 16-38 18t-41-11Z"
		/>
	</svg>
);
